import mitt from 'mitt'

export const emitter = mitt()

export const EventKeys = {
    SCAN_QR_PRODUCT: 'APP_TO_WEB_SCAN_QR_PRODUCT'
}